// extracted by mini-css-extract-plugin
module.exports = {"remainedWidthColumn":"ActivitiesPageTable_remainedWidthColumn__nuAs3","unitRow":"ActivitiesPageTable_unitRow__36GFI","subunitRow":"ActivitiesPageTable_subunitRow__2RMGZ"};